import { useState } from "react";

type Props = {
  onSubmit: (params: { email: string; inviteCode: string }) => void;
  onCancel: () => void;
  error?: string | null;
  loading?: boolean;
};

const INVITE_CODE_RE = /^[A-Z0-9]{8}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function normalizeInviteCode(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
}

function normalizeEmail(value: string): string {
  return value.trim();
}

export function EmailInviteInputCard({ onSubmit, onCancel, error, loading = false }: Props) {
  const [email, setEmail] = useState("");
  const [inviteCode, setInviteCode] = useState("");

  const normalizedEmail = normalizeEmail(email);
  const canSubmit = EMAIL_RE.test(normalizedEmail) && INVITE_CODE_RE.test(inviteCode) && !loading;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!canSubmit) return;
    onSubmit({ email: normalizedEmail, inviteCode });
  };

  return (
    <div className="mt-10">
      <p className="text-sm font-bold text-[#5D4D46]">メールアドレスと招待コードを入力してください</p>
      <p className="mt-1 text-xs leading-5 text-[#9C867D]">
        現在は招待制でご利用いただけます。メール認証機能は今後対応予定です。
      </p>

      <form onSubmit={handleSubmit} className="mt-4 space-y-3">
        <input
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="you@example.com"
          autoFocus
          autoComplete="email"
          disabled={loading}
          className="w-full rounded-2xl border border-[#EADBC8] bg-white px-4 py-3 text-sm text-[#4A3E39] placeholder-[#C9B8AF] outline-none focus:border-[#A67C52] focus:ring-2 focus:ring-[#A67C52]/20 disabled:opacity-50"
        />

        <input
          type="text"
          value={inviteCode}
          onChange={(event) => setInviteCode(normalizeInviteCode(event.target.value))}
          maxLength={8}
          placeholder="招待コード"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="characters"
          spellCheck={false}
          disabled={loading}
          className="w-full rounded-2xl border border-[#EADBC8] bg-white px-4 py-3 text-center font-mono text-lg tracking-[0.25em] text-[#4A3E39] placeholder-[#C9B8AF] outline-none focus:border-[#A67C52] focus:ring-2 focus:ring-[#A67C52]/20 disabled:opacity-50"
        />

        {error ? (
          <p className="rounded-2xl border border-[#E8B2A8] bg-[#FFF3F1] px-4 py-3 text-xs font-medium text-[#A1493E]">
            {error}
          </p>
        ) : null}

        <button
          type="submit"
          disabled={!canSubmit}
          className="w-full rounded-2xl bg-[#A67C52] px-4 py-3 text-sm font-bold text-white shadow-sm hover:bg-[#8C6540] active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {loading ? "登録中..." : "メールアドレスで始める"}
        </button>
      </form>

      <button
        type="button"
        onClick={onCancel}
        disabled={loading}
        className="mt-4 w-full text-xs text-[#9C867D] hover:text-[#7B6861] disabled:opacity-50"
      >
        戻る
      </button>
    </div>
  );
}
